<template>
  <div class="">
    <v-card-title class="mb-8 pa-0">
      Dashboard Overview
    </v-card-title>
    <v-row class="pa-0">
      <v-col cols="12" md="3">
        <v-card
          elevation="0"
        >
          <v-list-item three-line>
            <v-list-item-avatar class="mr-1">
              <v-icon
                large
                color="#000000"
              >
                mdi-truck-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="today-sales-title font-weight-bold" style="color:#000000">
                {{ formatNumber(summary.total_shipment) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Total Shipment</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          elevation="0"
        >
          <v-list-item three-line>
            <v-list-item-avatar class="mr-1">
              <v-icon
                large
                color="#9ECC5E"
              >
                mdi-truck-fast-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="today-sales-title font-weight-bold" style="color:#9ECC5E">
                {{ formatNumber(summary.for_delivery) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">For Dispatch</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          elevation="0"
        >
          <v-list-item three-line>
            <v-list-item-avatar class="mr-1">
              <v-icon
                large
                color="#005EB8"
              >
                mdi-truck-fast-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="today-sales-title font-weight-bold" style="color:#005EB8">
                {{ formatNumber(summary.ongoing) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">On-Going Dispatch</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card
          elevation="0"
        >
          <v-list-item three-line>
            <v-list-item-avatar class="mr-1">
              <v-icon
                large
                color="success"
              >
                mdi-cube-outline
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="today-sales-title font-weight-bold" style="color:#4caf50">
                {{ formatNumber(summary.delivered) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium ml-1 today-sales-subtitle">Dispatched Shipment</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

        <v-card elevation="0" class="pa-6 pt-4 mt-4">
          <v-card-title>
            For Dispatch
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              class="table-search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details>
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="bookings"
            :server-items-length="pagination.total"
            :items-per-page="pagination.per_page"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
            :loading="loading"
            loading-text="Loading For Dispatches..."
            item-key="item"
            no-data-text="No For Dispatches Found"
            :options.sync="options"
            ref="table">

            <template v-slot:[`item.shipping_mark`]="{ item }">
              <v-tooltip bottom v-if="item.has_storage_fee">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    color="error"
                    class="mr-2">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>Need to settle storage fee</span>
              </v-tooltip>

              <v-icon
                size="24"
                class="mr-2">
                {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
              </v-icon>
              {{ item.shipping_mark }}
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              {{ formatNumber(item.qty) }}
            </template>

            <template v-slot:[`item.cbm`]="{ item }">
              <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.cbm) }} CBM</span>
              <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.kg) }} KG</span>
            </template>

            <template v-slot:[`item.client_name`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-2">
                  mdi-account-outline
                </v-icon>
                {{ item.client_name }}
              </div>
            </template>

            <template v-slot:[`item.sales_agent`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-1">
                  mdi-face-agent
                </v-icon>

                {{ item.sales_agent }}
              </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | moment("MM-D-YYYY") }}
            </template>


            <template v-slot:item.action="{ item }">
              <v-chip
                text-color="white"
                color="primary"
                @click="viewItem(item.id)"
              >
                <span class="pa-2">Create Delivery Order</span>
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12">

        <v-card elevation="0" class="pa-6 pt-4 mt-4">
          <v-card-title>
            Has Storage Fee Items
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchHasStorageFee"
              class="table-search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details>
            </v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="hasStorageFeeItems"
            :search="searchHasStorageFee"
            :items-per-page="1000"
            hide-default-footer
            :loading="loading"
            loading-text="Loading Has Storage Fee Items..."
            item-key="item"
            no-data-text="No Has Storage Fee Items Found"
            :options.sync="options"
            ref="table">

            <template v-slot:[`item.shipping_mark`]="{ item }">
              <v-tooltip bottom v-if="item.has_storage_fee">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    color="error"
                    class="mr-2">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>Need to settle storage fee</span>
              </v-tooltip>
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-2">
                  {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
                </v-icon>
                {{ item.shipping_mark }}
              </div>
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              {{ formatNumber(item.qty) }}
            </template>

            <template v-slot:[`item.cbm`]="{ item }">
              <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.cbm) }} CBM</span>
              <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.kg) }} KG</span>
            </template>

            <template v-slot:[`item.sales_agent`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-1">
                  mdi-face-agent
                </v-icon>

                {{ item.sales_agent }}
              </div>
            </template>

            <template v-slot:[`item.client_name`]="{ item }">
              <div class="d-flex align-center">
                <v-icon
                  size="24"
                  class="mr-2">
                  mdi-account-outline
                </v-icon>
                {{ item.client_name }}
              </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | moment("MM-D-YYYY") }}
            </template>


            <template v-slot:item.action="{ item }">
              <v-chip
                text-color="white"
                color="primary"
                @click="viewItem(item.id)"
              >
                <span class="pa-2">Create Delivery Order</span>
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BookingStatusLabel from '@/components/BookingStatusLabel.vue'

export default {
  name: 'DashboardOps',
  data: () => ({
    operationsNamespace: 'operations',
    firstLoad: true,
    searchHasStorageFee: '',
    loading: false,
    search: '',
    awaitingSearch: false,
    selected: [],
    statuses: [],
    bookings: [],
    hasStorageFeeItems: [],
    agents: [],
    summary: {
      pending: 0,
      for_delivery: 0,
      completed: 0,
      ongoing: 0,
      total_shipment: 0,
      delivered: 0
    },
    pagination: {
      page: 1,
      per_page: 1,
      total: 0,
      next: 0
    },
    options: {},
    headers: [
      {
        text: 'Shipping Mark',
        align: 'start',
        value: 'shipping_mark',
        sortable: false
      },
      {
        text: 'Container',
        align: 'start',
        value: 'container',
        sortable: false
      },
      {
        text: 'Description',
        align: 'start',
        value: 'description',
        sortable: false,
      },
      {
        text: 'Qty',
        align: 'right',
        value: 'qty',
        sortable: false,
      },
      {
        text: 'Measure',
        align: 'right',
        value: 'cbm',
        sortable: false,
      },
      {
        text: 'Client Name',
        align: 'start',
        value: 'client_name',
        sortable: false,
      },
      {
        text: 'Sales Agent',
        align: 'start',
        value: 'sales_agent',
        sortable: false,
      }
    ]
  }),

  computed: {
    ...mapGetters(['formatNumberAmount', 'formatNumber', 'forSea'])
  },
  watch: {
    options: {
      handler () {
        this.getBookings()
      },
      deep: true,
    },
    search: function (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.options.page = 1
          this.getBookings()
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
  },
  methods: {
    isShipmentForSea (shipment_type){
      return this.forSea(shipment_type, this)
    },
    getAgentName: function(id){
      let agents = this.agents.filter(agent => {
        return agent.id == id
      })
      if(agents.length > 0){
        let agent = agents[0]
        return agent.first_name + ' ' + agent.last_name
      }
    },
    getStatusName: function(id){
      let statuses = this.statuses.filter(status => {
        return status.id == id
      })
      if(statuses.length > 0){
        return statuses[0].name
      }
    },
    getDefaultData () {
      let self = this
      this.$http.plain.get('/default-data?booking_statuses=true&agents=true')
        .then(response => {
          this.statuses = response.data.booking_statuses
          this.agents = response.data.agents
        })
        .catch(error => {
          console.log(error);
        })
    },
    getSummary () {
      let self = this
      this.$http.plain.get(this.operationsNamespace+'/deliveries/summary')
        .then(response => {
          this.summary = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    getHasStorageFeeItems () {
      let self = this
      this.$http.plain.get(this.operationsNamespace+'/has-storage-fee-items')
        .then(response => {
          this.hasStorageFeeItems = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    viewItem (id) {
      this.$router.push({ name: 'booking-view', params: { id: id } })
    },
    getBookings () {
      if (this.loading) {
        return false
      }

      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sorting = []
      let params = []

      if (sortBy.length === 1 && sortDesc.length === 1) {
        sortBy.forEach(function (item, index) {
          let sort = 'ASC'
          if (!sortDesc[index]) {
            sort = 'DESC'
          }
          sorting.push(item+'='+sort)
        });
      }

      if (this.search.length > 0){
        params.push('&search='+this.search)
      }

      this.loading = true
      let self = this
      this.$http.plain.get(this.operationsNamespace+'/for-deliveries?page='+ page + '&per_page=' + itemsPerPage + params.join())
        .then(response => {
          this.bookings = response.data.bookings

          if (response.data.pagination) {
            let pagination = response.data.pagination

            this.pagination.total = pagination.count
          }

        })
        .catch(error => {
          console.log(error);
        })
        .then(function () {
          self.loading = false
        })
      }
  },
  mounted () {
    this.getDefaultData()
    this.getSummary()
    this.getHasStorageFeeItems()
  },
  components: {
    BookingStatusLabel
  },
};
</script>
